import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

// Initialize Amplify with environment variables instead of aws-exports
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolClientId,

      loginWith: {
        email: true,
      },
      userAttributes: {
        email: {
          required: true,
        },
      },
      signUpVerificationMethod: 'link',
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
      mfa: {
        totpEnabled: true,
      },
    },
  },
});

bootstrapApplication(AppComponent, appConfig()).catch((err) => console.error(err));
